import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export function useSchemaDelete() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (uuid: string): Promise<void> => {
      const response = await fetch(
        `${import.meta.env.VITE_CRUD_ENGINE_ENDPOINT}/bundles/crud_bundle/functions/delete_schema`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({
            uuid
          }),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to delete schema');
      }
    },
    onSuccess: () => {
      setTimeout(() => {
        queryClient.invalidateQueries(['userDataclasses']);
      }, 1000);
    },
  });
}
